import { createContext } from 'react';
const TrackerContext = /*#__PURE__*/createContext({});
export default TrackerContext;